import { fetchWithFallback } from "../OrgUsageAnalytics/api";

// Mounted at /admin/referral-eligibility on the backend. fetchWithFallback adds
// the second "/admin" prefix and the acting admin's userId, and targets the
// selected environment (prod/dev) with localhost fallbacks.
const BASE = "/referral-eligibility";

// Current org-can-refer-users docs joined with org names and active overrides.
export async function listReferralEligibleOrganizations(env) {
  return fetchWithFallback(`${BASE}/organizations`, {}, { env });
}

// Addy staff on the production admin allow-list (name + email when available).
export async function listReferralAdmins(env) {
  return fetchWithFallback(`${BASE}/admins`, {}, { env });
}

// Recompute eligibility from live criteria and reconcile org-can-refer-users.
export async function syncReferralEligibility(env, { dryRun = false } = {}) {
  return fetchWithFallback(
    `${BASE}/sync`,
    {},
    { env, method: "POST", body: { dryRun } },
  );
}

// Aggregate referral funnel + delivery + UI-click analytics for a date range.
// `days` is a lookback window (1..180); aggregate counts only, no recipient PII.
export async function getReferralAnalytics(env, { days = 30 } = {}) {
  return fetchWithFallback(`${BASE}/analytics`, { days }, { env });
}

// Find an organization by name prefix or exact id before adding an override.
export async function searchReferralOrganizations(env, query) {
  return fetchWithFallback(`${BASE}/search`, { query }, { env });
}

// Create/update a durable override. type is "force_allow" | "force_deny".
// Materializes the matching add/remove in org-can-refer-users immediately.
export async function createReferralOverride(env, { organizationId, type, reason }) {
  return fetchWithFallback(
    `${BASE}/overrides`,
    {},
    { env, method: "POST", body: { organizationId, type, reason } },
  );
}

// Clear an override so automatic eligibility resumes on the next daily sync.
export async function clearReferralOverride(env, organizationId) {
  return fetchWithFallback(
    `${BASE}/overrides/${encodeURIComponent(organizationId)}`,
    {},
    { env, method: "DELETE" },
  );
}
